<app-page titolo="Il tuo profilo" sottotitolo="Come compari sugli articoli e sul sito">
  @if (caricamento()) {
    <p class="etichetta">Caricamento…</p>
  } @else {
    <form class="scheda profilo" [formGroup]="profileForm">
      <div class="avatar-scelta">
        <div
          class="avatar-scelta__riquadro"
          [class.success]="uploadSuccess"
          [class.error]="uploadError"
          (drop)="onFileDrop($event)"
          (dragover)="onDragOver($event)"
        >
          <input type="file" accept="image/*" (change)="onFileChange($event)" hidden #fileInput />
          <button type="button" class="avatar-scelta__bersaglio avatar-scelta__bersaglio--grande" (click)="fileInput.click()">
            @if (imagePreview()) {
              <img [src]="imagePreview()" alt="Il tuo avatar" />
            } @else {
              <span class="avatar-scelta__iniziali">{{ iniziali }}</span>
            }
          </button>
        </div>
        <div class="avatar-scelta__testo">
          <p class="etichetta">Avatar</p>
          <p>Compare accanto alla tua firma. Si salva appena lo scegli.</p>
          @if (imagePreview()) {
            <button type="button" mat-button (click)="removeImage()">Togli l'immagine</button>
          }
        </div>
      </div>

      <div class="profilo__campi">
        <mat-form-field>
          <mat-label>Nome e cognome</mat-label>
          <input matInput formControlName="blogger" />
          <mat-hint>È la firma che compare sugli articoli.</mat-hint>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" />
          <mat-hint>È l'indirizzo con cui entri: si cambia dalla gestione utenti.</mat-hint>
        </mat-form-field>
      </div>

      <h2 class="etichetta profilo__sezione">Profili social</h2>
      <div class="profilo__campi">
        <mat-form-field>
          <mat-label>Facebook</mat-label>
          <input matInput formControlName="url_facebook" placeholder="https://facebook.com/…" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>X (Twitter)</mat-label>
          <input matInput formControlName="url_twitter" placeholder="https://x.com/…" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>LinkedIn</mat-label>
          <input matInput formControlName="url_linkedin" placeholder="https://linkedin.com/in/…" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Google</mat-label>
          <input matInput formControlName="url_google" />
        </mat-form-field>
      </div>

      <div class="profilo__azioni">
        <button type="button" mat-flat-button color="primary" [disabled]="salvataggioInCorso()" (click)="save()">
          {{ salvataggioInCorso() ? 'Salvataggio…' : 'Salva' }}
        </button>
      </div>
    </form>
  }
</app-page>
